import { BrokerModelWithPermissions } from './get-server-side-props-utils/withAuthUser'

export const canSeeCommissionDetails = (user?: BrokerModelWithPermissions | null) => {
  if (!user) return false

  return user?.permissions?.canSeeCommissionDetailsInPartnerPortal ?? false
}
